import {
  formatDate,
  formatTime,
} from "../../../../../../../../utils/date-time-utility";
import {
  getAddressFormat,
  getValueFromObj,
} from "../../../../../../../../utils/utils";

interface OrderPrintProps {
  data: any;
}

/**
 * OrderPrint component to display the order print
 * Expects pre-formatted data from PatientOrderNew component
 *
 * @author [Atish Bagate]
 */
const OrderTemplate = ({ data }: OrderPrintProps) => {
  return (
    <div
      style={{
        backgroundColor: "rgba(243, 244, 246, 0.3)",
        fontFamily: "Arial, sans-serif",
      }}
    >
      <div
        style={{
          backgroundColor: "#fff",
          border: "1px solid #e5e7eb",
          borderRadius: "8px",
          boxShadow: "0 10px 15px -3px rgba(0, 0, 0, 0.1)",
          width: "100%",
        }}
      >
        {/* Content */}
        <div style={{ padding: "5px" }}>
          <div
            style={{
              display: "flex",
              justifyContent: "space-between",
              alignItems: "flex-start",
              marginBottom: "16px",
            }}
          >
            <div style={{ display: "flex", alignItems: "center", gap: "12px" }}>
              <div
                style={{ width: "64px", height: "64px", position: "relative" }}
              >
                <svg
                  viewBox="0 0 64 64"
                  style={{ width: "100%", height: "100%" }}
                >
                  <path
                    d="M20 10 L20 30 L15 45 C13 50 18 55 25 55 L39 55 C46 55 51 50 49 45 L44 30 L44 10"
                    fill="none"
                    stroke="#1e40af"
                    strokeWidth="3"
                    strokeLinecap="round"
                  />
                  <ellipse
                    cx="32"
                    cy="48"
                    rx="10"
                    ry="5"
                    fill="#22c55e"
                    opacity="0.6"
                  />
                  <circle cx="28" cy="42" r="4" fill="#22c55e" />
                  <circle cx="36" cy="38" r="3" fill="#1e40af" />
                  <circle cx="30" cy="35" r="2" fill="#22c55e" />
                  <path
                    d="M20 10 L44 10"
                    stroke="#1e40af"
                    strokeWidth="3"
                    strokeLinecap="round"
                  />
                  <path
                    d="M18 10 L22 5 M46 10 L42 5"
                    stroke="#1e40af"
                    strokeWidth="2"
                    strokeLinecap="round"
                  />
                </svg>
              </div>
              <div>
                <span
                  style={{
                    fontSize: "20px",
                    fontWeight: "bold",
                    color: "#1e40af",
                  }}
                >
                  {getValueFromObj(data?.labs) || "Lenco"}
                </span>
                <br />
                <span
                  style={{
                    fontSize: "20px",
                    fontWeight: "bold",
                    color: "#22c55e",
                  }}
                >
                  Diagnostic
                </span>
              </div>
            </div>
            <div
              style={{
                textAlign: "right",
                fontSize: "14px",
                color: "#1f2937",
              }}
            >
              <p style={{ fontWeight: 600, margin: 0 }}>
                {getValueFromObj(data?.labs) || "-"}
              </p>
              <p style={{ margin: 0 }}>
                {getAddressFormat(data?.patientAddress) || "-"},
              </p>
            </div>
          </div>

          <div style={{ paddingTop: "8px", marginBottom: "16px" }}>
            <div
              style={{
                display: "flex",
                flexDirection: "column",
                alignItems: "flex-start",
              }}
            >
              {/* bar code  */}

              {/* <div style={{ display: "flex", gap: "2px" }}>
                {Array.from({ length: 60 }).map((_, i) => (
                  <div
                    key={i}
                    style={{
                      width: Math.random() > 0.5 ? "2px" : "1px",
                      height: "35px",
                      backgroundColor: "black",
                    }}
                  />
                ))}
              </div> */}
              {/* <span
                style={{ fontSize: "14px", color: "#1f2937", marginTop: "4px" }}
              >
                {data?.labReferenceId || "-"}
              </span> */}
            </div>
          </div>

          <div
            style={{
              backgroundColor: "#3b82f6",
              color: "white",
              textAlign: "center",
              padding: "8px 0",
              fontSize: "14px",
              fontWeight: 500,
              borderRadius: "4px",
              marginBottom: "16px",
            }}
          >
            {data?.orderType || "LAB"} ORDER REPORT
          </div>

          <div style={{ display: "flex", gap: "16px", marginBottom: "16px" }}>
            <div
              style={{
                flex: 1,
                display: "flex",
                flexDirection: "column",
                gap: "4px",
              }}
            >
              <div style={{ display: "flex", gap: "32px" }}>
                <div
                  style={{
                    display: "flex",
                    gap: "4px",
                    flexWrap: "nowrap",
                    marginBottom: "4px",
                    justifyContent: "space-between",
                    width: "100%",
                  }}
                >
                  <span style={{ fontWeight: 600, fontSize: "12px" }}>
                    PRACTICE NUMBER :
                  </span>
                  <p style={{ fontSize: "12px", margin: 0 }}>
                    {data?.practiceNpi || "-"}
                  </p>
                </div>
                <div
                  style={{
                    display: "flex",
                    gap: "4px",
                    flexWrap: "nowrap",
                    marginBottom: "4px",
                    justifyContent: "space-between",
                    width: "100%",
                  }}
                >
                  {/* <span style={{ fontWeight: 600, fontSize: "12px" }}>
                    NETWORK -
                  </span>{" "}
                  <span style={{ fontSize: "12px" }}>-</span> */}
                </div>
              </div>
              <div style={{ fontSize: "12px", marginTop: "8px" }}>
                <p style={{ margin: 0 }}>{data?.providerGroupName || "-"}</p>
                <p style={{ margin: 0 }}>Pratice</p>
                <p style={{ margin: 0 }}>
                  {getAddressFormat(data?.labAddress) || "-"}
                </p>
              </div>
            </div>
            <div
              style={{
                border: "1px solid #e5e7eb",
                padding: "12px",
                minWidth: "220px",
              }}
            >
              <p
                style={{
                  fontWeight: 600,
                  fontSize: "12px",
                  margin: "0 0 4px 0",
                }}
              >
                PATIENT INFORMATION
              </p>
              <p style={{ fontSize: "12px", margin: 0 }}>
                {data?.patientName || "-"}
              </p>
              <p style={{ fontSize: "12px", margin: 0 }}>
                {data?.patientAddress?.line1 || "-"}
              </p>
            </div>
          </div>

          <div
            style={{
              border: "1px solid #e5e7eb",
              display: "grid",
              gridTemplateColumns: "repeat(2, 1fr)",
              marginBottom: "16px",
            }}
          >
            {/* Box 1: Collection Date, Time, Lab Ref ID */}

            <div style={{ padding: "12px", borderRight: "1px solid #e5e7eb" }}>
              <div
                style={{
                  display: "flex",
                  gap: "4px",
                  flexWrap: "nowrap",
                  marginBottom: "4px",
                  justifyContent: "space-between",
                  width: "100%",
                }}
              >
                <div
                  style={{
                    display: "flex",
                    gap: "4px",
                    flexWrap: "wrap",
                    marginBottom: "4px",
                  }}
                >
                  <span style={{ fontWeight: 600, fontSize: "12px" }}>
                    COLLECTION DATE -
                  </span>
                  <span style={{ fontSize: "12px" }}>
                    {formatDate(data?.collectionDateTime) || "-"}
                  </span>
                </div>
                <div
                  style={{
                    display: "flex",
                    gap: "4px",
                    flexWrap: "wrap",
                    marginBottom: "4px",
                  }}
                >
                  <span style={{ fontWeight: 600, fontSize: "12px" }}>
                    {" "}
                    TIME -
                  </span>
                  <span style={{ fontSize: "12px" }}>
                    {formatTime(data?.collectionDateTime, {
                      withSeconds: true,
                    }) || "-"}
                  </span>
                </div>
              </div>
              <div
                style={{
                  display: "flex",
                  gap: "4px",
                  flexWrap: "wrap",
                  marginBottom: "4px",
                }}
              >
                <span style={{ fontWeight: 600, fontSize: "12px" }}>
                  LAB REFERENCE ID -
                </span>
                <span style={{ fontSize: "12px" }}>
                  {data?.labReferenceId || "-"}
                </span>
              </div>
            </div>

            {/* Box 2: Patient ID, SSN, DOB, Gender */}
            <div style={{ padding: "12px", borderRight: "1px solid #e5e7eb" }}>
              <div
                style={{
                  display: "flex",
                  gap: "4px",
                  flexWrap: "nowrap",
                  marginBottom: "4px",
                  justifyContent: "space-between",
                  width: "100%",
                }}
              >
                <div
                  style={{
                    display: "flex",
                    gap: "4px",
                    flexWrap: "wrap",
                    marginBottom: "4px",
                  }}
                >
                  <span style={{ fontWeight: 600, fontSize: "12px" }}>
                    PATIENT ID -
                  </span>
                  <span
                    style={{ fontSize: "12px" }}
                  >{`#${data?.patientId?.split("-")?.[0]?.toUpperCase() || "-"}`}</span>
                </div>
                <div
                  style={{
                    display: "flex",
                    gap: "4px",
                    flexWrap: "wrap",
                    marginBottom: "4px",
                  }}
                >
                  <span style={{ fontWeight: 600, fontSize: "12px" }}>
                    {" "}
                    SSN -
                  </span>
                  <span style={{ fontSize: "12px" }}>{data?.ssn || ""}</span>
                </div>
              </div>
              <div
                style={{
                  display: "flex",
                  gap: "4px",
                  flexWrap: "nowrap",
                  marginBottom: "4px",
                  justifyContent: "space-between",
                  width: "100%",
                }}
              >
                <div
                  style={{
                    display: "flex",
                    gap: "4px",
                    flexWrap: "wrap",
                    marginBottom: "4px",
                  }}
                >
                  <span style={{ fontWeight: 600, fontSize: "12px" }}>
                    DOB -
                  </span>
                  <span style={{ fontSize: "12px" }}>
                    {formatDate(data?.birthDate) || "-"}
                  </span>
                </div>
                <div
                  style={{
                    display: "flex",
                    gap: "4px",
                    flexWrap: "wrap",
                    marginBottom: "4px",
                  }}
                >
                  <span style={{ fontWeight: 600, fontSize: "12px" }}>
                    GENDER -
                  </span>
                  <span style={{ fontSize: "12px" }}>
                    {data?.gender || "-"}
                  </span>
                </div>
              </div>
            </div>
          </div>
          <div
            style={{
              border: "1px solid #e5e7eb",
              marginBottom: "16px",
            }}
          >
            <div
              style={{ display: "grid", gridTemplateColumns: "repeat(2, 1fr)" }}
            >
              <div
                style={{
                  padding: "12px",
                  borderRight: "1px solid #e5e7eb",
                }}
              >
                {/* provider id */}
                {/* <div>
                  <span style={{ fontWeight: 600, fontSize: "12px" }}>
                    PROVIDER ID -
                  </span>{" "}
                  <span style={{ fontSize: "12px" }}>
                    {data?.providerId || "-"}
                  </span>
                </div> */}
                <div style={{ marginTop: "4px" }}>
                  <span style={{ fontWeight: 600, fontSize: "12px" }}>
                    NPI NUMBER -
                  </span>{" "}
                  <span style={{ fontSize: "12px" }}>
                    {data?.providerNpi || ""}
                  </span>
                </div>
              </div>
              <div style={{ padding: "12px" }}>
                <div>
                  <span style={{ fontWeight: 600, fontSize: "12px" }}>
                    BILL TYPE -
                  </span>{" "}
                  <span style={{ fontSize: "12px" }}>
                    {data?.billType || "-"}
                  </span>
                </div>
                <div style={{ marginTop: "4px" }}>
                  <span style={{ fontWeight: 600, fontSize: "12px" }}>
                    INSURANCE NAME -
                  </span>{" "}
                  <span style={{ fontSize: "12px" }}>
                    {data?.insuranceName || "-"}
                  </span>
                </div>
              </div>
            </div>
          </div>

          <div style={{ border: "1px solid #e5e7eb", padding: "12px" }}>
            <div style={{ marginBottom: "12px" }}>
              <span style={{ fontWeight: 600, fontSize: "12px" }}>
                PATIENT INSTRUCTIONS -
              </span>{" "}
              <span style={{ fontSize: "12px" }}>
                {data?.patientInstruction || "-"}
              </span>
            </div>
            <div
              style={{
                display: "grid",
                gridTemplateColumns: "repeat(2, 1fr)",
                gap: "16px",
              }}
            >
              <div>
                <p
                  style={{
                    fontWeight: 600,
                    fontSize: "12px",
                    margin: "0 0 4px 0",
                  }}
                >
                  LAB TESTS -
                </p>
                {data?.labTests?.length > 0 ? (
                  <ul
                    style={{
                      fontSize: "12px",
                      margin: 0,
                      paddingLeft: "16px",
                      listStyleType: "disc",
                    }}
                  >
                    {data.labTests.map((test: string, index: number) => (
                      <li key={index} style={{ marginBottom: "2px" }}>
                        {test}
                      </li>
                    ))}
                  </ul>
                ) : (
                  <p style={{ fontSize: "12px", margin: 0 }}>-</p>
                )}
              </div>
              <div>
                <p
                  style={{
                    fontWeight: 600,
                    fontSize: "12px",
                    margin: "0 0 4px 0",
                  }}
                >
                  ICD CODE -
                </p>
                {data?.icdCodes?.length > 0 ? (
                  <ul
                    style={{
                      fontSize: "12px",
                      margin: 0,
                      paddingLeft: "16px",
                      listStyleType: "disc",
                    }}
                  >
                    {data.icdCodes.map((code: string, index: number) => (
                      <li key={index} style={{ marginBottom: "2px" }}>
                        {code}
                      </li>
                    ))}
                  </ul>
                ) : (
                  <p style={{ fontSize: "12px", margin: 0 }}>-</p>
                )}
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default OrderTemplate;
